import { memo } from "react";
import { formatTimeFromUtc } from "utils/formatters";
import { getYearsFromUtc } from "utils/general";
import { Divider, Grid, Typography } from "@mui/material";
import { Clinician } from "types/Clinician";
import PatientInfoText from "./components/PatientInfoText";

type Props = {
  firstName: string;
  lastName: string;
  uniqueId: string;
  patientImage: string;
  dateOfBirth: string;
  email?: string;
  gender?: string;
  phone?: string;
  id?: string;
  teamLead?: string;
  teamMembers?: Clinician[];
};

export const PatientInfo = memo(
  ({
    firstName,
    lastName,
    uniqueId,
    patientImage,
    dateOfBirth,
    email,
    gender,
    phone,
    id,
    teamLead,
    teamMembers,
  }: Props) => {
    return (
      <div className="w-full flex card rounded-[20px] pt-7 justify-between pb-7 px-8 md:flex-col md:space-y-8  mb-5">
        <Grid container spacing={2}>
          <Grid xs={6}>
            <div className="flex space-x-7 sm:flex-col sm:space-x-0 sm:space-y-4">
              <div className="w-[100px] h-[100px] rounded-full bg-grayDark overflow-hidden shrink-0">
                <img className="object-cover min-w-full min-h-full" src={patientImage} alt="avatar" />
              </div>
              <div className="flex flex-col items-start min-h-[125px]">
                <h5 className="text-grayDark text-[11 px]">Patient ID#: {id}</h5>
                <p className="text-[38px] font-black">
                  {firstName} {lastName}
                </p>
              </div>
            </div>
          </Grid>
          <Grid xs={6}>
            <Grid xs={12} container>
              <Grid xs={4}>
                <div className="flex flex-col pl-5">
                  <PatientInfoText firstText="DOB" secondText={formatTimeFromUtc(dateOfBirth)} />
                  <PatientInfoText firstText="Phone" secondText={phone} />
                </div>
              </Grid>
              <Grid xs={4}>
                <div className="flex flex-col pl-5">
                  <PatientInfoText firstText="Age" secondText={getYearsFromUtc(dateOfBirth) + ""} />
                  <PatientInfoText firstText="Email" secondText={email} />
                </div>
              </Grid>
              <Grid xs={4}>
                <div className="flex flex-col pl-5">
                  <PatientInfoText firstText="Gender" secondText={gender} />
                </div>
              </Grid>
            </Grid>
            <Grid xs={12} sx={{ marginTop: 2 }}>
              <Typography
                sx={{
                  color: '#5C5D68',
                  fontWeight: 600,
                  fontSize: '18px',
                  lineHeight: '24px',
                  paddingLeft: 3,
                }}
              >
                Patient Care Team
              </Typography>
            </Grid>
            <Divider style={{ margin: 8 }} />
            <Grid xs={12} container>
              <Grid xs={6}>
                <div className="flex flex-col pl-5">
                  <PatientInfoText firstText="Assigned Team Lead" secondText={teamLead || "-"} />
                </div>
              </Grid>
              <Grid xs={6}>
                <div className="flex flex-col pl-5">
                  <p>
                    <PatientInfoText firstText="Assigned Team Members" secondText={teamMembers?.length ? teamMembers.map((item) => {
                      const first = item?.profileInfo?.firstName;
                      const last = item?.profileInfo?.lastName;
                      if (!first && !last) return null;
                      return `${first ?? ""} ${last ?? ""}`.trim();
                    }).filter(Boolean).join('\n') || "-" : "-"} />
                  </p>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
);